import React, { useContext, useState } from "react";
import { Box, Divider, Link, Typography } from "@material-ui/core";
import { useDeviceTypes } from "halifax";
import clsx from "clsx";
import "./styles.scss";
import { RoomInfoProducts } from "redmond";
import { RouteComponentProps } from "react-router";
import { PaymentScheduleCardProps } from "./container";
import { HotelRoomPaymentScheduleModal } from "../../../shop/components/HotelRoomPaymentScheduleModal";
import {
  EDIT,
  PAY_LATER_LABEL,
  PAY_LATER_NOTES,
  PAY_NOW_LABEL,
  STEP_SUBTITLE,
  STEP_TITLE,
} from "./textConstants";
import { AGENT_FEE } from "..";
import { ClientContext } from "../../../../App";

export interface IPaymentScheduleCardProps
  extends PaymentScheduleCardProps,
    RouteComponentProps {
  disabled?: boolean;
}

export const PaymentScheduleCard = ({
  disabled,
  selectRoomType,
  chosenRoomInfoIndex,
  chosenRoomInfo,
  isPayLater,
  selectedAccount,
  ancillaries,
  schedulePriceQuote,
  history,
}: IPaymentScheduleCardProps) => {
  const { matchesMobile } = useDeviceTypes();

  const clientContext = useContext(ClientContext);
  const { isAgentPortal } = clientContext;
  const [modalRoomInfoProducts, setModalRoomInfoProducts] = useState<
    undefined | RoomInfoProducts
  >(undefined);

  const openModal = () => {
    setModalRoomInfoProducts(chosenRoomInfo as RoomInfoProducts);
  };

  const closeModal = () => {
    setModalRoomInfoProducts(undefined);
  };

  const renderPaymentSchedule = () => (
    <Box
      className={clsx("payment-schedule-container", {
        mobile: matchesMobile,
        disabled,
      })}
    >
      <Typography className="step-title" variant="h2">
        {STEP_TITLE}
      </Typography>
      <Typography variant="body2" className="payment-step-subtitle">
        {STEP_SUBTITLE}
      </Typography>
      <Divider className="divider" />
      <Box
        className={clsx("payment-schedule", {
          mobile: matchesMobile,
          disabled,
        })}
      >
        <Box>
          <Typography>
            {isPayLater
              ? PAY_LATER_LABEL(selectedAccount?.productDisplayName ?? "")
              : PAY_NOW_LABEL(selectedAccount?.productDisplayName ?? "")}
          </Typography>

          {isPayLater && (
            <span className="paylater-notes">{PAY_LATER_NOTES}</span>
          )}
        </Box>

        <Link
          disabled={disabled}
          component="button"
          onClick={(e) => {
            e.stopPropagation();
            openModal();
          }}
          className="edit-payment-schedule"
        >
          {EDIT}
        </Link>
      </Box>
    </Box>
  );

  return (
    <>
      {renderPaymentSchedule()}
      {modalRoomInfoProducts && (
        <HotelRoomPaymentScheduleModal
          openModal={modalRoomInfoProducts !== undefined}
          onClose={() => {
            closeModal();
          }}
          onClickContinue={(selectedProductIndex: number) => {
            selectRoomType(chosenRoomInfoIndex, selectedProductIndex);
            schedulePriceQuote({
              history,
              agentFee: isAgentPortal ? AGENT_FEE : 0,
              pollQuoteOnly: true,
              ancillaries,
            });

            closeModal();
          }}
          roomInfoProducts={modalRoomInfoProducts}
          isMobile={false}
        />
      )}
    </>
  );
};
